import { TeamEventContext } from '@/support/teamEvents/TeamEventContext';
import { type FC, type PropsWithChildren } from 'react';

// HOTFIX: team-events SSE disabled — pinned-thread XREAD loop in the messaging service pegs CPU
// and restarts pods under load. Re-enable (git revert) once TeamEventStreamController migrates
// to non-blocking ReactiveStringRedisTemplate. Subscribers no-op via TeamEventContext=null.
export const TeamEventProvider: FC<PropsWithChildren> = ({ children }) => (
  <TeamEventContext.Provider value={null}>{children}</TeamEventContext.Provider>
);
